
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { LeadForm } from "@/components/LeadForm";
import { CSVUploader } from "@/components/CSVUploader";

const LeadUpload = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  
  return (
    <div className="max-w-2xl mx-auto">
      {error && (
        <Alert variant="destructive" className="mb-4">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}

      <Tabs defaultValue="manual" className="w-full">
        <TabsList className="grid w-full grid-cols-2 mb-6">
          <TabsTrigger value="manual">Manual Entry</TabsTrigger>
          <TabsTrigger value="csv">CSV Upload</TabsTrigger>
        </TabsList>
        
        <TabsContent value="manual">
          <LeadForm />
        </TabsContent>
        
        <TabsContent value="csv">
          <CSVUploader />
        </TabsContent>
      </Tabs>
      
      <div className="mt-6 flex justify-end">
        <Button 
          variant="outline" 
          onClick={() => navigate("/dashboard")}
          className="airbnb-button"
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default LeadUpload;
